// export const DEV_SERVER = "http://0.0.0.0:8000"
// export const DEV_SERVER = "https://dev.sauron.6thlabs.com"
// export const GRPC_SERVER = "http://dev.sauron.6thlabs.com:5001"
// export const GRPC_SERVER = "https://dev.sauron.6thlabs.com"

// let dev_server = "http://localhost:5000"
// let grpc_server = "http://localhost:5001"
let dev_server = "https://backend.optimiz.dhanveen.com";
dev_server = "http://127.0.0.1:5000";

let grpc_server = "https://backend.optimiz.dhanveen.com/grpc";
// let ws_url = "wss://backend.optimiz.dhanveen.com/ws/";
// let ws_url = "ws://localhost:5003/ws/";
let ws_url = "ws://192.168.1.76:5003/ws/";

if (process.env.REACT_APP_ENV === "PROD") {
  dev_server = "https://backend.sauron.6thlabs.com";
  // grpc_server = "https://backend.sauron.6thlabs.com"
} else if (process.env.REACT_APP_ENV === "DEV") {
  // dev_server = "https://backend.optimiz.dhanveen.com"
  // grpc_server = "https://backend.optimiz.dhanveen.com/grpc";
  // dev_server = "http://192.168.1.7:5000"
  dev_server = "http://127.0.0.1:5000";
  grpc_server = "http://192.168.1.7:5001";
}

dev_server = "https://backend.willow.dhanveen.com";
grpc_server = "https://backend.willow.dhanveen.com/grpc";
ws_url = "wss://backend.willow.dhanveen.com/ws/";

export const DEV_SERVER = dev_server;
export const GRPC_SERVER = grpc_server;
export const WS_URL = ws_url;
